<template>
  <form @submit.prevent="submitHandler">

    <div class="alert alert-danger text-center" v-if="errMsg">
      {{ errMsg }}
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">{{$t("Password")}}:</label>
      <div class="col-sm-10">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': !$v.formData.password.required && $v.formData.password.$dirty }]"
          @blur="$v.formData.password.$touch()"
          v-model="formData.password">
        <div class="invalid-feedback">
          {{$t("Please, enter the password")}}
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-sm-2 col-form-label col-form-label-sm">{{$t("Repeat Password")}}:</label>
      <div class="col-sm-10">
        <input type="password"
          class="form-control form-control-sm"
          :class="[{ 'is-invalid': (!$v.formData.repPassword.required && $v.formData.repPassword.$dirty) || !$v.formData.repPassword.sameAsPass }]"
          @blur="$v.formData.repPassword.$touch()"
          v-model="formData.repPassword">
        <div class="invalid-feedback">
          {{ $v.formData.repPassword.sameAsPass ? $t("Repeated password is not the same") : $t("Please, repeat the password") }}
        </div>
      </div>
    </div>

    <button type="submit" class="btn btn-lg btn-block btn-success" :disabled="$v.formData.$invalid">{{$t("Set Password")}}</button>

    <loading :loading="loading"></loading>

  </form>
</template>


<script>
import { required, sameAs } from 'vuelidate/lib/validators'
import userService from '../../services/userService'

export default {
  props: ['id', 'token'],
  validations: {
    formData: {
      password: {
        required,
      },
      repPassword: {
        required,
        sameAsPass: sameAs('password'),
      },
    },
  },
  data() {
    return {
      formData: {
        password: null,
        repPassword: null,
      },
      loading: false,
      errMsg: null,
    }
  },
  methods: {
    submitHandler() {
      if (!this.$v.formData.$invalid) {
        this.loading = true
        userService.setNewPass(this.token, this.id, this.formData.password)
          .then(res => {
            this.$emit('actionSuccess')
          })
          .catch(errRes => {
            this.errMsg = errRes.error
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/components/forms/ResetPasswordForm.vue